import { AGENT_STATUS } from './agent-premium';
export class Agent {
    get isActive() {
        return this.isReady || this.isAssigned || this.isServiceRequested;
    }
    get isAssigned() {
        return this.isCheckIn || this.isCheckOut;
    }
    get isReady() {
        return this.premium != null &&
            this.premium.agentStatus != null &&
            this.premium.agentStatus === AGENT_STATUS.READY;
    }
    get isOut() {
        return this.premium != null &&
            this.premium.agentStatus != null &&
            this.premium.agentStatus === AGENT_STATUS.OUT;
    }
    get isCheckIn() {
        return this.premium != null &&
            this.premium.agentStatus != null &&
            (this.premium.agentStatus === AGENT_STATUS.CHECK_IN ||
                this.premium.agentStatus === AGENT_STATUS.CHECK_IN_START ||
                this.premium.agentStatus === AGENT_STATUS.CHECK_IN_COMPLETED);
    }
    get isCheckOut() {
        return this.premium != null &&
            this.premium.agentStatus != null &&
            (this.premium.agentStatus === AGENT_STATUS.CHECK_OUT ||
                this.premium.agentStatus === AGENT_STATUS.CHECK_OUT_START ||
                this.premium.agentStatus === AGENT_STATUS.CHECK_OUT_COMPLETED);
    }
    get isServiceRequested() {
        return this.premium != null &&
            this.premium.agentStatus != null &&
            this.premium.agentStatus === AGENT_STATUS.SERVICE_REQUESTED;
    }
    get isMultiReception() {
        return this.premium != null &&
            this.premium.agentStatus != null &&
            this.premium.multireception && this.premium.id_multireception_terminal != null;
    }
    isServiceRequestActive() {
        if (!this.isServiceRequested) {
            return false;
        }
        return this.secondsLeftToExpireRequest() > 0;
    }
    secondsLeftToExpireRequest() {
        return Math.floor((+this.premium.requestExpirationTime - +new Date) / 1000);
    }
}
//# sourceMappingURL=agent.js.map